/*
  Faro — Relevancia de búsqueda.

  Problema: la búsqueda nativa de Shopify une los términos con OR, así que
  agregar palabras AMPLÍA los resultados en vez de acotarlos
  ("toalla blanca" devolvía más que "toalla"). El cliente percibe basura.

  Solución: unir los términos con AND antes de enviar la consulta, y mostrar
  al cliente la consulta limpia (sin el operador) en el input y en el título.

  No toca consultas avanzadas: si el usuario ya escribió AND/OR/NOT, usó
  comillas, paréntesis o un filtro tipo "tag:x", se respeta tal cual.
*/
(function () {
  var AVANZADA = /(^|\s)(AND|OR|NOT)(\s|$)|["()]|\w+:/;

  function aAnd(valor) {
    var v = (valor || '').trim().replace(/\s+/g, ' ');
    if (!v || AVANZADA.test(v)) return v;
    var partes = v.split(' ');
    return partes.length > 1 ? partes.join(' AND ') : v;
  }

  function limpiar(valor) {
    return (valor || '').replace(/\s+AND\s+/g, ' ');
  }

  // 1) Al enviar cualquier formulario de búsqueda
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if ((form.getAttribute('action') || '').indexOf('/search') === -1) return;
      var input = form.querySelector('input[name="q"]');
      if (input) input.value = aAnd(input.value);
    },
    true
  );

  // 2) Al hacer clic en "ver todos los resultados" de la búsqueda predictiva
  document.addEventListener(
    'click',
    function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href*="/search"]') : null;
      if (!a) return;
      try {
        var url = new URL(a.href, window.location.origin);
        var q = url.searchParams.get('q');
        if (!q) return;
        var nuevo = aAnd(q);
        if (nuevo !== q) {
          url.searchParams.set('q', nuevo);
          a.href = url.toString();
        }
      } catch (err) {
        /* href no parseable: se deja igual */
      }
    },
    true
  );

  // 3) En la página de resultados, mostrar la consulta sin el operador
  function ordenarVista() {
    var inputs = document.querySelectorAll('input[name="q"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value && inputs[i].value.indexOf(' AND ') !== -1) {
        inputs[i].value = limpiar(inputs[i].value);
      }
    }
    if (document.title.indexOf(' AND ') !== -1) {
      document.title = limpiar(document.title);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ordenarVista);
  } else {
    ordenarVista();
  }
})();
